import React, {memo, useCallback, useRef, useState} from 'react';
import {RgbaColor} from 'react-colorful';
import {useLocalizer} from '@/common/services/localizer';
import {useOutsideClick} from '@/common/helpers/hooks/useOutsideClick';
import {useGlobalHotkey} from '@/common/helpers/hooks/useGlobalHotkey';
import {ColorPicker} from '@/common/components/ColorPicker';
import styles from './PreviewBackgroundPicker.css';

interface PreviewBackgroundPickerProps {
	value: RgbaColor;
	onChange(value: RgbaColor): void;
}

export const PreviewBackgroundPicker = memo<PreviewBackgroundPickerProps>(props => {
	const {value, onChange} = props;
	const t = useLocalizer();

	const pickerRef = useRef<HTMLDivElement>(null);

	const [opened, setOpened] = useState(false);

	const handleOpenSwitch = () => {
		setOpened(!opened);
	};

	const handleClose = useCallback(() => {
		setOpened(false);
	}, []);

	useOutsideClick(pickerRef, handleClose, opened);
	useGlobalHotkey('Escape', handleClose, opened);

	return (
		<div className={styles.root}>
			<button className={styles.targetButton} type='button' onClick={handleOpenSwitch}>
				{t('previewBgChange')}
			</button>
			{opened && (
				<ColorPicker
					ref={pickerRef}
					className={styles.picker}
					value={value}
					onChange={onChange}
					onClose={handleClose}
				/>
			)}
		</div>
	);
});

PreviewBackgroundPicker.displayName = 'PreviewBackgroundPicker';
